<!-- Preview -->
<div *ngIf="previewUrl" class="image-container-upload"
    [ngClass]="{ 'slicks-mode': isSlicks, 'wallpaper-mode': previewVariant === 'wallpaper', 'logo-mode': previewVariant === 'logo' }">
    <ng-container [ngSwitch]="mediaType">
        <img *ngSwitchCase="'image'" [src]="previewUrl" class="image-preview-upload"
            [ngClass]="{ 'wallpaper-object': previewVariant === 'wallpaper', 'logo-object': previewVariant === 'logo' }"
            [style.width.%]="isSlicks ? 100 : null" />
        <video *ngSwitchCase="'video'" [src]="previewUrl" class="video-preview-upload" autoplay [muted]="true" controls
            [style.width.%]="isSlicks ? 100 : null"></video>
    </ng-container>

    <button *ngIf="canEdit" pButton pRipple type="button" icon="pi pi-times" class="close-button"
        (click)="handleRemove()"></button>
</div>


<!-- Upload area -->
<ng-container *ngIf="!previewUrl && !forceHidePreview">
    <div class="custom-upload-area-cmp"  [ngClass]="{ 'highlight-drag': isDragOver }" (click)="abrirUpload()" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

        <!-- Ícone e texto -->
        <div class="upload-content-cmp">
            <i class="pi pi-cloud-upload upload-icon-cmp"></i>
            <span class="upload-text-cmp">Arraste ou selecione um arquivo aqui</span>
        </div>

        <!-- Input invisível -->
        <ng-container *ngIf="!isNativeAndroid()">
            <input #fileInput type="file" [accept]="getAcceptMime()" (change)="handleFileChange($event)"
                class="mobile-file-input-overlay-cmp" />
        </ng-container>
    </div>
</ng-container>

<!-- Error messages -->
<div class="flex flex-column mt-2" *ngIf="!previewUrl">
    <small *ngIf="errorSize" class="p-error">
        {{ invalidAttemptType === 'image'
        ? 'Tamanho da imagem deve ser de no máximo 1 mega'
        : 'O vídeo deve ter no máximo 400 MB.' }}
    </small>
    <small *ngIf="errorType" class="p-error">
        {{ invalidAttemptType === 'image'
        ? 'Tipo da imagem deve ser .png, .webp, avif, jfif, .jpg ou jpeg'
        : 'Tipos de vídeo permitidos: mp4, mov, mp3, wav, webm, avi, wmv, mkv, flv, mpeg, mpg, 3gp, m4v.' }}
    </small>
    <small *ngIf="required && requiredError" class="p-error">
        Obrigatório
    </small>
</div>

